export const TERM_DEPOSIT_STATUS = {
  PENDING: "PENDING",
  REFUND: "REFUND",
  REFUSE: "REFUSE",
  SUCCESS: "SUCCESS",
} as const;
